import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { VerificationProcessSection } from "./VerificationProcessSection";
import { TutorOnboardingStepper } from "../TutorProfile/TutorOnboardingStepper";
import { useTutorOnboardingNavigation } from "../../hooks/useTutorOnboardingNavigation";
import ProfileUnderReviewCard from "../ProfileUnderReviewCard";

export const GetVerified = () => {
  const step = "verify";
  const location = useLocation();
  const [profileUnderReviewOpen, setProfileUnderReviewOpen] = useState(
    Boolean(location.state?.showProfileUnderReview),
  );
  const { onStepClick } = useTutorOnboardingNavigation(step);

  return (
    <div className="w-full min-h-screen bg-[#f5f7fa] flex flex-col">
      {/* Header Section */}
      <div className="w-full bg-gradient-to-b from-[#A8C7F0] to-[#2A66B8] pt-12 pb-16">
        <div className="max-w-7xl mx-auto px-6 flex flex-col items-center">
          <h1 className="text-white text-6xl font-normal mb-4 text-center">
            Verify Your Identity
          </h1>

          <p className="text-[#DAEAFE] text-lg text-center max-w-3xl leading-relaxed">
            We keep our platform safe by verifying all tutors.
          </p>
          <p className="text-[#DAEAFE] text-lg mb-10 text-center max-w-3xl leading-relaxed">
            Complete your background check securely.
          </p>

          <TutorOnboardingStepper activeKey={step} onStepClick={onStepClick} />
        </div>
      </div>
      
      {/* Main Content */}
      <div className="relative flex-1 w-full">
        <div className="w-full max-w-7xl mx-auto px-6 py-12">
          <VerificationProcessSection
            onShowProfileUnderReview={() => setProfileUnderReviewOpen(true)}
          />
        </div>

        {profileUnderReviewOpen && (
          <div className="absolute inset-0 z-40 flex items-start justify-center bg-black/30 px-4 py-6 md:py-10">
            <div
              role="dialog"
              aria-modal="false"
              aria-label="Profile Under Review"
              className="w-full max-w-2xl"
            >
              <ProfileUnderReviewCard />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { VerificationStatusPage } from "./VerificationStatusPage";
